import ProjectSession from "../../project-session"
import ProjectSingleViewProperties from "./productivity-proto"

export default class ProjectSingleViewChatsProperties extends ProjectSingleViewProperties {

    constructor(properties:any, project:ProjectSession) {
        super(properties, project)

        this.canCreateDiscussion = true
    }
}
